import { render, staticRenderFns } from "./UserHeaderRegister.vue?vue&type=template&id=6c0c1045"
import script from "./UserHeaderRegister.vue?vue&type=script&lang=js"
export * from "./UserHeaderRegister.vue?vue&type=script&lang=js"
import style0 from "./UserHeaderRegister.vue?vue&type=style&index=0&id=6c0c1045&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports